import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDatepickerModule } from '@angular/material/datepicker';
//spinner
import { HttpService } from './services/http.service';
import { TokenDecodeService } from './services/token-decode.service';
import { CustomToastComponent } from './component/custom-toast/custom-toast.component';
import { TokenInterceptor } from './services/token.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { DatepickerModule } from './component/datepicker/datepicker.component';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';

@NgModule({ declarations: [
        AppComponent,
        CustomToastComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatDatepickerModule,
        DatepickerModule,
        ToastrModule.forRoot({
            toastComponent: CustomToastComponent,
            positionClass: "toast-bottom-right",
            closeButton: true
        }),
        NgHttpLoaderModule.forRoot(),
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFireAuthModule], providers: [{
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        }, HttpService, TokenDecodeService, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
